export const getPlacementCardStyles = () => ({
  placementCardRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    position: 'relative',
    boxSizing: 'content-box',
    overflow: 'hidden',
    background: '#FFFFFF',
    borderRadius: 12,
    margin: 'auto',

    '& .card-parent': {
      width: 'fit-content',
      '& .placement-card-content': {
        boxShadow:
          '0px 0.511px 1.533px rgb(0 0 0 / 10%), 0px 2.72533px 6.132px rgb(0 0 0 / 13%)',
        border: 'solid thin #ddd',
        borderRadius: 12,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        margin: 'auto',
        position: 'relative',
      },
    },
  },
});
